/**
 * @generated SignedSource<<01b260d190b6a876d277c15688fd9b4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
import { FragmentRefs } from "relay-runtime";
export type useGetDepartmentAvailabilityFilterBarValues_department$data = {
  readonly facilities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly copyOverrides: {
          readonly course: {
            readonly plural: string;
            readonly singular: string;
          } | null | undefined;
        };
        readonly type: FacilityType;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"useDepartmentGolfFacilitiesStartEndTime_department">;
  readonly " $fragmentType": "useGetDepartmentAvailabilityFilterBarValues_department";
};
export type useGetDepartmentAvailabilityFilterBarValues_department$key = {
  readonly " $data"?: useGetDepartmentAvailabilityFilterBarValues_department$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetDepartmentAvailabilityFilterBarValues_department">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetDepartmentAvailabilityFilterBarValues_department",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useDepartmentGolfFacilitiesStartEndTime_department"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "FacilityConnection",
      "kind": "LinkedField",
      "name": "facilities",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FacilityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FacilityCopyOverrides",
                  "kind": "LinkedField",
                  "name": "copyOverrides",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "NounOverride",
                      "kind": "LinkedField",
                      "name": "course",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "singular",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "plural",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Department",
  "abstractKey": null
};

(node as any).hash = "fdf48bafbe01cae543c7546cf7dc0e8e";

export default node;
